import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchAP, deleteAP, fetchAPDetail, clearAPDetail } from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

import APList from '../../components/AP/APList';

const apList = reduxForm({
    form: 'apList',
    destroyOnUnmount: false,
})(APList);

const selector = formValueSelector('apList');

function mapStateToProps(state) {
    const fromDate = selector(state, 'FromDate');
    const toDate = selector(state, 'ToDate');
    const days = selector(state, 'Days');
    return {
        fromDate,
        toDate,
        days,
        ap: state.arap.ap,
        isLoading: state.arap.apIsLoading,
        error: state.arap.apError,
        apDetail: state.arap.apDetail,
        apDetailError: state.arap.apDetailError,
        apDetailIsLoading: state.arap.apDetailIsLoading,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
    };
}

export default connect(mapStateToProps, {
  fetchAP,
  deleteAP,
  fetchAPDetail,
  clearAPDetail,
  setDefaultOfForm,
  checkPassword,
  clearCheckPassword,
})(apList);



// WEBPACK FOOTER //
// ./master/jsx/containers/AP/APList.jsx